<template>
   <section class="container relative mx-auto">
      <div class="xs:p-8 mx-auto rounded-xl p-4 md:flex md:p-12 xl:p-16" :class="`theme-${containerTheme}`">
         <div>
            <Kicker v-if="kicker" class="mb-2" :text="kicker" />

            <h2 v-if="heading" class="h2 text-header mb-8 shrink-0 md:w-1/4 lg:w-2/5">
               {{ heading }}
            </h2>

            <p v-if="description">
               {{ description }}
            </p>
         </div>

         <div class="mt-6 shrink-0 md:w-3/4 md:pl-8 lg:w-3/5">
            <Accordion
               v-for="(faqItem, index) in faqItems"
               :key="`faq-${index}`"
               :name="`faq-${index}`"
               :buttonClosedClasses="`text-left leading-normal text-lg md:text-xl text-bolder pb-2 pt-4 md:pb-4 md:pt-6 ${
                  index === 0 ? '' : 'border-t'
               }`"
               :buttonOpenClasses="`text-left leading-normal text-lg md:text-xl text-bolder pb-2 pt-4 md:pb-4 md:pt-6 ${
                  index === 0 ? '' : 'border-t'
               }`"
            >
               <template #header>{{ faqItem.question }}</template>
               <template #content>
                  <RichTextRenderer v-if="faqItem.answer" :document="faqItem.answer" />
               </template>
            </Accordion>
         </div>
      </div>
   </section>
</template>

<script setup lang="ts">
import { Theme, type ContainerTheme } from "@/types";

// props
// -----------------------------------------
const props = withDefaults(
   defineProps<{
      heading: string;
      faqItems: {
         type: "faq_item";
         question: string;
         answer: string;
      }[];
      kicker?: string;
      description?: string;
      theme?: ContainerTheme;
   }>(),
   {
      theme: Theme.BrandDark,
   }
);

const containerTheme = computed(() => (props.theme ? props.theme : Theme.BrandDark));
</script>

<style scoped></style>
